import Group from "../../imagem/Group 149.png";
import "./SobreAlunos.css";
import fotoLabers2024 from "../../imagem/foto_labers_2024.svg";
import fotoLabers2025 from "../../imagem/foto_labers_2025.jpeg";

function SobreAluno() {
  return (
    <div className="container_sobre">
      <h1>Sobre o Instituto YouX</h1>

      <div className="caixa_texto_img">
        <span>
          Fundado em 12 de abril de 2024, na cidade de Lavras/MG, o Instituto YouX
          nasceu a partir da iniciativa da YouX com o propósito de{" "}
          <strong>
            promover a cidadania ativa e a construção de um futuro sustentável
          </strong>
          . Desde então, o Instituto YouX tem atuado para criar oportunidades de
          aprendizado e crescimento profissional, ajudando a moldar uma geração
          de talentos aptos a enfrentar os desafios do cenário digital.
        </span>

        <div>
          <img src={Group} alt="Logo Instituto YouX" />
        </div>
      </div>

      <h1>Sobre o YouX Lab</h1>

      <div className="caixa_sobre_lab">
        <div>
          <p>
            O YouX Lab é um programa social de desenvolvimento de jovens talentos
            que tem como propósito transformar vidas por meio da tecnologia e da
            inovação. Para isso, desenvolvemos uma metodologia de ensino
            inovadora para capacitar estudantes do ensino médio, oferecendo a
            oportunidade de inserção no mercado de trabalho.
          </p>

          <span>
            O YouX Lab é <strong>totalmente gratuito</strong> e todos os
            participantes do programa, os Labers,{" "}
            <strong>recebem todo o apoio necessário</strong> para darem
            continuidade ao seu desenvolvimento no Lab e na escola, incluindo{" "}
            <strong>
              bolsa mensal, auxílio transporte, equipamentos e alimentação
            </strong>{" "}
            durante toda a jornada de aprendizado.
          </span>
        </div>

        <p>
          O programa YouX Lab tem duração aproximada de 10 meses e é dividido em
          ciclos que desenvolvem habilidades socioemocionais, culturais e
          técnicas por meio de atividades práticas. Ao final do programa, os
          próprios Labers desenvolvem um produto digital real, que é doado à
          sociedade.
        </p>
      </div>

      <h1>Sobre o Conexão Literária</h1>

      <div className="caixa_sobre_conexao">
        <p>
          O Conexão Literária foi criado em 2024 como um projeto piloto
          desenvolvido pelos Labers do YouX Lab com o objetivo de apoiar escolas
          públicas na gestão de seus acervos literários. A partir das
          dificuldades identificadas em bibliotecas escolares, foi desenvolvido
          um sistema para facilitar a administração e o controle desses acervos.
        </p>

        <p>
          Como parte desse processo, os estudantes participaram ativamente de
          entrevistas com educadores, levantamento de necessidades e testes de
          usabilidade, garantindo que a solução atendesse de forma prática e
          eficiente às demandas reais das escolas.
        </p>
      </div>


      <div className="img_labers">
        <img src={fotoLabers2024} alt="Turma YouX Lab 2024" />
      </div>

      <h2>Sobre a evolução do Conexão Literária</h2>

      <div className="caixa_sobre_conexao">
        <p>
          Em 2025, o Conexão Literária evoluiu para uma nova versão, ampliando
          suas funcionalidades e aprimorando a experiência dos usuários. A
          plataforma passou a contar com perfis personalizados, histórico de
          leitura, recomendações de livros e recursos de gamificação.
        </p>

        <p>
          Essa evolução foi construída a partir das experiências da versão
          inicial, reforçando o caráter contínuo e colaborativo do projeto,
          desenvolvido por diferentes turmas do YouX Lab ao longo dos anos.
        </p>

        <p className="p_negrito">
          O Conexão Literária é, e sempre será, gratuito para todas as escolas
          públicas.
        </p>
      </div>

      <div className="img_labers">
        <img src={fotoLabers2025} alt="Turma YouX Lab 2025" />
      </div>
    </div>
  );
}

export default SobreAluno;
